import {
  ChevronLeft,
  ChevronRight,
  CornerLeftUp,
  Plus,
  RefreshCcw,
  Save,
  Search,
  Send,
} from "react-feather";
import Spinner from "../Spinner";
import useAuthority from "../../hooks/useAuthority";
import { AUTHORITY_TYPE } from "../../const";
import { FaPlus } from "react-icons/fa";

const Button = ({
  onClick = () => {},
  Icon = null,
  label,
  className = "",
  color = "primary",
  floated = "right",
  type = "button",
  isLoading = false,
  style = { display: "flex", alignItems: "center" },
  create = true,
  template = "",
  imgSrc = "",
  disabled = false,
  form = null,
  module = null,
  authenticated = false,
  editMode = false,
  authType = AUTHORITY_TYPE.FORM,
  field = "",
  flip = false,
}) => {
  let content = <></>;
  const currentClassName = className
    ? className
    : `ui ${color} ${floated} floated button`;

  const { authorized } = useAuthority({
    type: authType,
    module,
    form,
    field,
    editMode,
    authenticated: authenticated,
  });

  switch (template) {
    case "addOrSave": {
      let buttonDisabled = false;
      if (authenticated && (!form || !module)) {
        buttonDisabled = true;
      }
      content = (
        <button
          className="ui primary right floated button"
          type="button"
          onClick={!isLoading && onClick}
          style={style}
          disabled={disabled || buttonDisabled || !authorized || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {isLoading ? (
              <Spinner size="tiny" color="white" />
            ) : (
              <>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {Icon ? (
                    <Icon size={15} style={{ marginRight: "5px" }} />
                  ) : create ? (
                    <Plus size={15} style={{ marginRight: "5px" }} />
                  ) : (
                    <Save size={15} style={{ marginRight: "5px" }} />
                  )}
                </div>
                <span>{label ? label : create ? "Add" : "Save"}</span>
              </>
            )}
          </div>
        </button>
      );
      break;
    }
    case "reset": {
      content = (
        <button
          className="ui secondary right floated button"
          type="button"
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <RefreshCcw size={15} style={{ marginRight: "5px" }} />
            </div>
            <span>Reset</span>
          </div>
        </button>
      );
      break;
    }
    case "searchReset": {
      content = (
        <button
          className="ui accent right floated button"
          type="button"
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <CornerLeftUp size={15} style={{ marginRight: "5px" }} />
            </div>
            <span>Reset</span>
          </div>
        </button>
      );
      break;
    }
    case "search": {
      content = (
        <button
          className="ui primary right floated button"
          type="button"
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Search size={15} style={{ marginRight: "5px" }} />
            </div>
            <span>{label ? label : "Search"}</span>
          </div>
        </button>
      );
      break;
    }
    case "imageButton": {
      content = (
        <button
          className={currentClassName}
          type={type}
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
            }}
          >
            <img
              style={{
                display: "inline-block",
                postion: "absolute",
                top: "0",
                right: "0",
                width: "50px",
                marginRight: "5px",
              }}
              src={imgSrc}
              alt="buttonImage"
            />

            <span
              style={{
                postion: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              {label}
            </span>
          </div>
        </button>
      );
      break;
    }
    case "next": {
      content = (
        <button
          className="ui secondary right floated button"
          type="button"
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>Next</span>
            <div style={{ display: "flex", alignItems: "center" }}>
              <ChevronRight size={15} style={{ marginLeft: "5px" }} />
            </div>
          </div>
        </button>
      );
      break;
    }
    case "back": {
      content = (
        <button
          className="ui secondary right floated button"
          type="button"
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <ChevronLeft size={15} style={{ marginRight: "5px" }} />
            </div>
            <span>Back</span>
          </div>
        </button>
      );
      break;
    }
    case "create": {
      let buttonDisabled = false;
      if (authenticated && (!form || !module)) {
        buttonDisabled = true;
      }
      content = (
        <button
          className="ui primary right floated button"
          type={type}
          onClick={!isLoading && onClick}
          style={style}
          disabled={disabled || buttonDisabled || !authorized || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {isLoading ? (
              <Spinner size="tiny" color="white" />
            ) : (
              <>
                {create ? (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Send size={15} style={{ marginRight: "5px" }} />
                    </div>
                    <span>Submit</span>
                  </>
                ) : (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Save size={15} style={{ marginRight: "5px" }} />
                    </div>
                    <span>Update</span>
                  </>
                )}
              </>
            )}
          </div>
        </button>
      );
      break;
    }
    case "submit": {
      let buttonDisabled = false;
      if (authenticated && (!form || !module)) {
        buttonDisabled = true;
      }
      content = (
        <button
          className="ui primary right floated button"
          type="button"
          onClick={!isLoading && onClick}
          style={style}
          disabled={disabled || buttonDisabled || !authorized || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {isLoading ? (
              <Spinner size="tiny" color="white" />
            ) : (
              <>
                {create ? (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Send size={15} style={{ marginRight: "5px" }} />
                    </div>
                    <span>{label ? label : "Submit"}</span>
                  </>
                ) : (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Save size={15} style={{ marginRight: "5px" }} />
                    </div>
                    <span>Update</span>
                  </>
                )}
              </>
            )}
          </div>
        </button>
      );
      break;
    }
    case "drawerOpen": {
      let buttonDisabled = false;
      if (authenticated && (!form || !module)) {
        buttonDisabled = true;
      }
      content = (
        <button
          className="ui primary button"
          type="button"
          onClick={!isLoading && onClick}
          style={style}
          disabled={disabled || buttonDisabled || !authorized || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FaPlus size={15} style={{ marginRight: "5px" }} />
            </div>
            <span>{label ? label : "Add"}</span>
          </div>
        </button>
      );
      break;
    }
    case "generateReport": {
      content = (
        <button
          className="ui primary right floated button"
          type="button"
          onClick={onClick}
          style={style}
          disabled={disabled || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {isLoading ? (
              <Spinner size="tiny" color="white" />
            ) : (
              <>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Save size={15} style={{ marginRight: "5px" }} />
                </div>
                <span>{label ? label : "Generate Report"}</span>
              </>
            )}
          </div>
        </button>
      );
      break;
    }
    default: {
      let buttonDisabled = false;
      if (authenticated && (!form || !module)) {
        buttonDisabled = true;
      }
      content = (
        <button
          className={currentClassName}
          type={type}
          onClick={!isLoading && onClick}
          style={style}
          disabled={disabled || buttonDisabled || !authorized || isLoading}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {isLoading ? (
              <Spinner size="tiny" color="white" />
            ) : (
              <>
                {Icon ? (
                  <>
                    {flip ? (
                      <>
                        <span>{label}</span>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Icon size={15} style={{ marginLeft: "5px" }} />
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Icon size={15} style={{ marginRight: "5px" }} />
                        </div>
                        <span>{label}</span>
                      </>
                    )}
                  </>
                ) : (
                  <span>{label}</span>
                )}
              </>
            )}
          </div>
        </button>
      );
    }
  }

  return content;
};

export default Button;
